import { OrderbookDataItem } from 'store/orderbook/types'
import { precisionForPrice } from './precision'
import Decimal from 'decimal.js'

export function combineOrderbook(list: OrderbookDataItem[], precision: string) {
  return list.reduce((p: OrderbookDataItem[], n) => {
    const _pn = p[p.length - 1]
    const price = precisionForPrice(n.price, precision)
    if (_pn?.price === price) {
      _pn.amount = Decimal.add(_pn.amount, n.amount).toFixed()
      return p
    } else {
      p.push({
        ...n,
        price: price,
        amount: n.amount,
      })
    }

    return p
  }, [])
}
